module.exports = __webpack_public_path__ + "static/media/comparison3.1ce56c4f.png";